import Iconmoon from '@deprecated-ui/common/Iconmoon';
import color from '@deprecated-ui/_style/color';
import React from 'react';
import { ActionIconWrapper } from './styled';

interface SliderButtonProps {
  onClick: () => void;
  type: 'next' | 'prev';
}

function SliderButton({ type, onClick }: SliderButtonProps) {
  const position = type === 'next' ? 'right' : 'left';

  return (
    <ActionIconWrapper position={position} onClick={onClick}>
      <Iconmoon
        className={`icon-toolbar_${type}`}
        color={color.light}
        hoverColor={color.light}
      />
    </ActionIconWrapper>
  );
}

export default SliderButton;
